import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const getRoomFeedbackById = createAsyncThunk('chat-room/getFeedbackForRoom', async ({ id }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/chat-room/getFeedbackForRoom/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const GetRoomFeedbackById = createSlice(
  {
    name: 'GetRoomFeedbackById',
    initialState,
    reducers: {},
    extraReducers: {
      [getRoomFeedbackById.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [getRoomFeedbackById.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [getRoomFeedbackById.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default getRoomFeedbackById;
